export const TwoFactorEndpoints = {
  // Phase 1 — the unauthenticated login flow
  loginVerify: `login/two-factor/verify`,
  loginSetup: `login/two-factor/setup`,
  loginSetupConfirm: `login/two-factor/setup/confirm`,

  // Phase 2 — not implemented on the backend yet
  status: `profile/two-factor`,
  profileSetup: `profile/two-factor/setup`,
  profileConfirm: `profile/two-factor/confirm`,

  reset: (id: string | number) => `two-factor/reset?id=${id}`
}
